import React from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import Address from "../../searchresults/Address";
import AssessmentInformation from "./AssessmentInformation";
import DeedInformation from "./DeedInformation";
import getBusinessName from "../../common/Business";
import getName from "../../common/Name";

const getPropertyRows = (props, property, addIndex, propsIndex, type) => {
  const rows = [];
  const entityRecords = _.get(property, "entities[0].entity");
  if (entityRecords !== undefined) {
    const firstEntityAddress = _.get(entityRecords[0], "address[0]");
    let title = "Details for ";
    if (firstEntityAddress !== undefined) {
      title = `${title} ${_.get(
        firstEntityAddress,
        "streetNumber[0]._",
        ""
      )} ${_.get(firstEntityAddress, "streetName[0]._", "")} ${_.get(
        firstEntityAddress,
        "streetSuffix[0]._",
        ""
      )}, ${_.get(firstEntityAddress, "city[0]._", "")}, ${_.get(
        firstEntityAddress,
        "state[0]._",
        ""
      )} ${_.get(firstEntityAddress, "zip5[0]._", "")}`;
    }
    rows.push(
      <Table.Row key={`propery_title_${type}_${addIndex}_${propsIndex}`}>
        <Table.Cell colSpan={2} className={"report-section-main-title"}>
          {title}
        </Table.Cell>
      </Table.Row>
    );
    _.forEach(entityRecords, (entity, entityIndex) => {
      const propetyType = _.get(entity, "entityType[0]._", "");
      rows.push(
        <Table.Row
          key={`prop_row1_${type}_${addIndex}_${propsIndex}_${entityIndex}`}
          className={"report-sub-title"}
        >
          <Table.HeaderCell colSpan={4}>
            <center>{propetyType}</center>
          </Table.HeaderCell>
        </Table.Row>
      );
      const rowsLeft = [];
      const address = _.get(entity, "address[0]");
      if (address !== undefined) {
        rowsLeft.push(
          <Table.Row
            key={`prop_row2_${type}_${addIndex}_${propsIndex}_${entityIndex}`}
          >
            <Table.Cell>Address:</Table.Cell>
            <Table.Cell colSpan={3}>
              <Address addressNode={entity.address[0]} />
            </Table.Cell>
          </Table.Row>
        );
      }
      const rowsRight = [];
      const names = _.get(entity, "names[0].name");
      if (names !== undefined) {
        _.forEach(names, (name, nameIndex) => {
          const companyName = _.get(name, "companyName[0]._", "");
          if (companyName !== "") {
            rowsRight.push(
              <Table.Row
                key={`Nam_row1_${type}_${addIndex}_${propsIndex}_${entityIndex}_${nameIndex}`}
              >
                <Table.Cell>Name:</Table.Cell>
                <Table.Cell colSpan={3}>N/A</Table.Cell>
              </Table.Row>
            );
            rowsRight.push(
              <Table.Row
                key={`Nam_row2_${type}_${addIndex}_${propsIndex}_${entityIndex}_${nameIndex}`}
              >
                <Table.Cell>Company Name:</Table.Cell>
                <Table.Cell colSpan={3}>
                  {getBusinessName(companyName, props)}
                </Table.Cell>
              </Table.Row>
            );
          } else {
            rowsRight.push(
              <Table.Row
                key={`Nam_row_${type}_${addIndex}_${propsIndex}_${entityIndex}_${nameIndex}`}
              >
                <Table.Cell>Name:</Table.Cell>
                <Table.Cell colSpan={3}>
                  {getName(
                    _.get(name, "first[0]._", ""),
                    "",
                    _.get(name, "last[0]._", ""),
                    props
                  )}
                </Table.Cell>
              </Table.Row>
            );
          }
        });
      }
      if (rowsLeft.length > 0 && rowsRight.length > 0)
        rows.push(
          <Table.Row
            key={`prop_main_row_${type}_${addIndex}_${propsIndex}_${entityIndex}`}
          >
            <Table.Cell>
              {
                <Table className={"table-no-border-and-padding"}>
                  <Table.Body>{rowsLeft}</Table.Body>
                </Table>
              }
            </Table.Cell>
            <Table.Cell>
              {
                <Table className={"table-no-border-and-padding"}>
                  <Table.Body>{rowsRight}</Table.Body>
                </Table>
              }
            </Table.Cell>
          </Table.Row>
        );
      else if (rowsLeft.length > 0) rows.push(rowsLeft);
      else rows.push(rowsRight);
    });
    const assessment = _.get(property, "assessment");
    if (assessment !== undefined) {
      rows.push(
        <Table.Row key={`assessment_info_${type}_${addIndex}_${propsIndex}`}>
          <Table.Cell colSpan={2}>
            <AssessmentInformation
              {...props}
              assessment={assessment}
              addIndex={addIndex}
              propsIndex={propsIndex}
            />
          </Table.Cell>
        </Table.Row>
      );
    }
    const deed = _.get(property, "deed");
    if (deed !== undefined) {
      rows.push(
        <Table.Row key={`deed_info_${type}_${addIndex}_${propsIndex}`}>
          <Table.Cell colSpan={2}>
            <DeedInformation
              {...props}
              deed={deed}
              addIndex={addIndex}
              propsIndex={propsIndex}
            />
          </Table.Cell>
        </Table.Row>
      );
    }
  }
  return (
    <Table.Row key={`prop_inner_${type}_${addIndex}_${propsIndex}`}>
      <Table.Cell>
        <Table>
          <Table.Body>{rows}</Table.Body>
        </Table>
      </Table.Cell>
    </Table.Row>
  );
};

export default getPropertyRows;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/PropertyByAddress.js